module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/solution3_1-21ad1a026c9c38ce82757af35fc16f7b.png";